var _style, _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirstAidWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "first-aid-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".first-aid-white_svg__st8{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M420 373.9h184v116.6h116.9v185.1H604.3v116.1H420V675.4H303.1V490.6h116.3V373.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M339.7 235.7V84.2h344.6v134.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 986.1,
    cy: 430.6,
    r: 32.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M986.1 493.5c-17.2 0-31.3 13.3-32.5 30.2-.1.8-.1 1.6-.1 2.4s0 1.6.1 2.4v378.8H70.4v-649h883.3v74.4c-.1.8-.1 1.6-.1 2.4s0 1.6.1 2.4c1.2 16.9 15.3 30.2 32.5 30.2s31.3-13.3 32.5-30.2c.1-.8.1-1.6.1-2.4s0-1.6-.1-2.4V225.8c0-17.9-14.6-32.5-32.5-32.5H37.9c-17.9 0-32.5 14.6-32.5 32.5v714c0 17.9 14.6 32.5 32.5 32.5h948.3c17.9 0 32.5-14.6 32.5-32.5V528.5c.1-.8.1-1.6.1-2.4s0-1.6-.1-2.4c-1.3-16.9-15.4-30.2-32.6-30.2z"
  })));
}

export default SvgFirstAidWhite;